export const HidePasswordIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M9.39136 4.44107C11.4296 4.19817 13.4913 4.62903 15.2616 5.66786C17.032 6.70668 18.4137 8.29638 19.1957 10.1942C19.2687 10.3906 19.2687 10.6067 19.1957 10.8032C18.8742 11.5828 18.4492 12.3156 17.9322 12.9819"
        stroke="var(--inzeloop-ds-color-action-primary-pressed)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3235 12.3885C11.8284 12.8667 11.1653 13.1313 10.4771 13.1253C9.7888 13.1193 9.13042 12.8432 8.64372 12.3565C8.15703 11.8698 7.88096 11.2115 7.87498 10.5232C7.869 9.83492 8.13358 9.17184 8.61175 8.67676"
        stroke="var(--inzeloop-ds-color-action-primary-pressed)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2941 15.3116C14.1334 15.9991 12.8384 16.429 11.4969 16.5719C10.1554 16.7149 8.79891 16.5676 7.51938 16.1401C6.23985 15.7126 5.06725 15.0148 4.08114 14.0942C3.09503 13.1736 2.31849 12.0516 1.8042 10.8044C1.73128 10.608 1.73128 10.3919 1.8042 10.1954C2.58001 8.31406 3.94504 6.73503 5.69445 5.69531"
        stroke="var(--inzeloop-ds-color-action-primary-pressed)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 1.75L19.25 19.25"
        stroke="var(--inzeloop-ds-color-action-primary-pressed)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
